export default function Reducer(state, action) {
  switch (action.type) {
    case "UPDATE_NAME_SHOW":
      return {
        ...state,
        nameShow: action.nameShow,
      };
    case "UPDATE_NAME":
      return {
        ...state,
        name: action.name,
        itens: state.itens.map((item) => ({ ...item, group: action.name })),
      };
    case "REPLACE_ITENS":
      return {
        ...state,
        itens: action.itens,
      };
    case "REMOVE_ITEM":
      return {
        ...state,
        itens: state.itens.filter((value, idx) => idx !== action.index),
      };
    case "START_EDIT_ITEM":
      return {
        ...state,
        inEditing: { status: true, index: action.index },
      };
    case "END_EDIT_ITEM":
      return {
        ...state,
        inEditing: { status: false },
      };
    case "UPDATE_ITEM":
      return {
        ...state,
        inEditing: { status: false },
        itens: state.itens.map((value, idx) => {
          if (idx === action.index) return action.item;
          return value;
        }),
      };
    case "UPDATE_ITEM_AND_NEXT":
      const isLast = state.itens.length === state.inEditing.index + 1;
      return {
        ...state,
        inEditing: isLast
          ? { status: false, index: 0 }
          : { status: true, index: state.inEditing.index + 1 },
        itens: state.itens.map((value, idx) => {
          if (idx === state.inEditing.index) return action.item;
          return value;
        }),
      };

    case "ADD_ITEM":
      return {
        ...state,
        itens: [
          ...state.itens,
          { ...action.item, group: state.name, is_active: true },
        ],
      };
    case "SET_REQUIRED":
      return {
        ...state,
        required: action.required,
      };
    case "CHANGE_FIELD":
      return {
        ...state,
        [action.field]: action.value,
      };
    default:
      return state;
  }
}
